class CustomVariantPicker extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const variantbuttons = this.querySelectorAll('[js-custom-variant-picker]');

        variantbuttons.forEach(button => {
            button.addEventListener('click', () => {
                variantbuttons.forEach(btn => btn.classList.remove('active'));
                button?.classList.add('active');
                const variantId = button?.dataset.variantId;
                const price = button?.dataset.price;

                const parent = button.closest('.Product_card_content_inner_new');
                const atcInput = parent?.querySelector('input[name="id"]');
                const atcPrice = parent?.querySelector('.add-to-cart-text .price');
                

                if (atcInput) {
                    atcInput.value = variantId;
                }
                if (atcPrice) {
                    atcPrice.textContent = price;
                }
            });
        });
    }
}

customElements.define('custom-variant-picker', CustomVariantPicker);